export const MEDIA_PLATFORM_DOMAIN: string =
  'wixmp-833713b177cebf373f611808.appspot.com';
export const MEDIA_PLATFORM_APP_ID: string = '9dd507ea4ab8410d9a4e2743958a7ca2';
export const MEDIA_PLATFORM_UPLOAD_URL: string =
  'wixmp-833713b177cebf373f611808.wixmp.com';
